// src/utils/covers.js
export const PLACEHOLDER =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'>
      <defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stop-color='#f5f7fa'/><stop offset='100%' stop-color='#c3cfe2'/>
      </linearGradient></defs>
      <rect width='100%' height='100%' fill='url(#g)'/>
      <text x='50%' y='50%' text-anchor='middle' dominant-baseline='middle'
            font-family='system-ui' font-size='22' fill='#334155' opacity='0.7'>No Cover</text>
    </svg>`
  );

/**
 * Normalize album cover URLs and try to request a decent size.
 * - Keeps /public relative paths and data: URIs as-is
 * - Upgrades protocol-relative // to https://
 * - WordPress: swaps -300x300.ext to -1024x1024.ext (or desired size)
 * - Wikimedia: /thumb/.../<W>px-... -> resized
 * - Dropbox: ?dl=0 -> ?raw=1 (direct)
 * - Googleusercontent: set size via ?s=<n>
 */
export function resolveCoverUrl(url, opts = { size: 1024 }) {
  const size = Math.max(64, Math.min(2048, Number(opts.size) || 1024));

  if (!url) return PLACEHOLDER;
  if (/^(data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/")) return url; // served from /public
  if (url.startsWith("//")) url = "https:" + url;

  try {
    const u = new URL(url);

    // Strip tracking/query noise
    u.search = "";
    u.hash = "";

    // WordPress style size suffix: filename-300x300.jpg
    u.pathname = u.pathname
      .replace(/-\d+x\d+(?=\.[a-z]+$)/i, `-${size}x${size}`)
      .replace(/-scaled(?=\.[a-z]+$)/i, "");

    // Wikimedia /thumb/…/<width>px-FILENAME
    if (
      u.hostname.includes("wikimedia.org") ||
      u.hostname.includes("wikipedia.org")
    ) {
      u.pathname = u.pathname.replace(/\/(\d+)px-/i, `/${size}px-`);
    }

    // Dropbox share -> raw
    if (u.hostname.includes("dropbox.com")) {
      u.search = "?raw=1";
    }

    // Googleusercontent sizing (e.g., lh3.googleusercontent.com)
    if (u.hostname.includes("googleusercontent.com")) {
      u.search = `?s=${size}`;
    }

    return u.toString();
  } catch {
    // If URL constructor fails (odd relative), just return original
    return url;
  }
}

/** One-shot fallback to PLACEHOLDER without looping forever. */
export function coverOnError(e) {
  const img = e && e.currentTarget;
  if (!img) return;
  if (img.dataset.fallbackApplied === "1") return;
  img.dataset.fallbackApplied = "1";
  img.src = PLACEHOLDER;
}
